import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

/**
 * Asks the listing to also return the patient's EpisodeOfCare-less visit diagnoses, which is how
 * single-encounter visits are charted. Opt-in: the Files pickers resolve the id they are given as
 * a real EpisodeOfCare, so they must keep receiving EpisodesOfCare only.
 */
const ENCOUNTER_DIAGNOSES_INCLUDE = "encounter-diagnoses";

interface EpisodesOfCareListParams {
  patientId: string;
  includeEncounterDiagnoses?: boolean;
}

type EpisodesOfCareListResponse = {
  id: string;
  title: string;
}[];

export const useEpisodesOfCareList = ({
  patientId,
  includeEncounterDiagnoses = false,
}: EpisodesOfCareListParams) => {
  const include = includeEncounterDiagnoses
    ? ENCOUNTER_DIAGNOSES_INCLUDE
    : undefined;

  return useApi<EpisodesOfCareListResponse>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<EpisodesOfCareListResponse>(
          `/charting/timeline/patient/${patientId}/episodes_of_care`,
          include ? { params: { include } } : undefined,
        );

        return response.data;
      },
      enabled: !!patientId,
      queryKey: QueryKeys.Patient.EpisodesOfCare.LIST(patientId, include),
    },
  });
};
